export default "__VITE_ASSET__A__2MDjJ__"